<div class="mb-myaccount-orderdetails"
     data-cy="mb-checkout-review"
     *ngIf="order$ | async as order">
  <div class="row no-gutters my-3 mb-myaccount-orderdetails-orderNumberTitle">
    <div class="col-12 mb-myaccount-orderdetails-orderNumberTitleText">
      <span >Order #{{order.code}}</span>
    </div>
  </div>
  <div class="row mt-2 no-gutters mb-myaccount-confirmation-order-info">
    <div class="col-12 col-sm-6">
      <div class="row no-gutters">
        <div *ngIf="order?.contactInformation"
             class="col-12 mb-myaccount-orderdetails-card-contactdetails">
          <mb-orderdetails-information-tile [title]="'review.contactDetails'"
                                            [data]="order.contactInformation"
                                            [type]="infoTypes.CONTACT_DETAILS"
                                            [isEditable]="false">
          </mb-orderdetails-information-tile>
        </div>
        <div *ngIf="order?.deliveryAddress"
             class="col-12">
          <mb-orderdetails-information-tile [title]="'review.shippingAddress'"
                                            [data]="order.deliveryAddress"
                                            [type]="infoTypes.ADDRESS"
                                            [isEditable]="false"
                                            [formRegion]="checkoutRegion">
          </mb-orderdetails-information-tile>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6">
      <div class="row no-gutters">
        <div *ngIf="order?.statusDisplay" class="col-12">
          <mb-orderdetails-information-tile [title]="'review.orderStatus'"
                                            [data]="order.statusDisplay"
                                            [type]="infoTypes.ORDER_STATUS"
                                            [isEditable]="false">
          </mb-orderdetails-information-tile>
        </div>

        <ng-container *ngIf="isPurchaseCheckoutType$ | async">
          <div class="col-12 mb-myaccount-orderdetails-card-shippingmethod">
            <mb-orderdetails-information-tile [title]="'review.shipmentMethod'"
                                              [type]="infoTypes.SHIPMENT_METHOD"
                                              [isEditable]="false">
            </mb-orderdetails-information-tile>
          </div>

          <div *ngIf="order?.paymentDetails?.paymentMode"
               class="col-12 mb-myaccount-orderdetails-card-payment">
            <mb-orderdetails-information-tile [title]="'review.paymentMethod'"
                                              [data]="order.paymentDetails?.paymentMode"
                                              [type]="infoTypes.PAYMENT_METHOD"
                                              [isEditable]="false"
                                              [formRegion]="checkoutRegion">
            </mb-orderdetails-information-tile>
          </div>

          <div class="col-12">
            <mb-orderdetails-information-tile [title]="'review.additionalInfo'"
                                              [data]="order.paymentDetails"
                                              [type]="infoTypes.PAYMENT_ADDITIONAL_INFO"
                                              [isEditable]="false"
                                              [formRegion]="checkoutRegion"
                                              [poNumberLabelKey]="'review.poInternalRefNum'">
            </mb-orderdetails-information-tile>
          </div>
        </ng-container>
        <div *ngIf="order?.paymentDetails?.billingAddress"
             class="col-12 mb-myaccount-orderdetails-card mb-myaccount-orderdetails-card-billingaddress">
          <mb-orderdetails-information-tile [title]="'review.billingInformation'"
                                            [data]="order.paymentDetails?.billingAddress"
                                            [type]="infoTypes.ADDRESS"
                                            [isEditable]="false"
                                            [formRegion]="checkoutRegion"
                                            [vatIdLabelKey]="'address.vatId'">
          </mb-orderdetails-information-tile>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="order?.checkoutNotes"
       class="row no-gutters mt-4 mb-myaccount-confirmation-order-info">
    <div class="col-12">
      <mb-orderdetails-information-tile [title]="'review.notes'"
                                        [data]="order.checkoutNotes"
                                        [type]="infoTypes.NOTES"
                                        [isEditable]="false">
      </mb-orderdetails-information-tile>
    </div>
  </div>

  <ng-container *ngIf="orderEntries$ | async as orderEntries">
    <div class="row no-gutters mt-5">
      <div class="col-12 mb-3 mb-myaccount-confirmation-cart-headline">
        <strong>{{ 'mbcommon.yourCart' | cxTranslate }}</strong>
      </div>
    </div>
    <div class="row no-gutters mt-1">
      <div class="col-12">
        <mb-cart-details [isDisplayedInCartPage]="false"
                         [orderEntries]="orderEntries"
                         [isCustomerSpecificPrices]="order?.erpPricesAreCustomerSpecific && !order?.erpPricingError"
                         [showAddToCartButton]="true"
                         [dataAnalyticsClickSource]="dataAnalyticsClickSource">
        </mb-cart-details>
      </div>
    </div>
  </ng-container>
  <mb-myaccount-button
    [path]="'mbOrders'"
    [textTranslationPath]="'mbMyAccount.backToOrderHistory'"></mb-myaccount-button>
</div>
<mb-myaccount-mobile-navigation></mb-myaccount-mobile-navigation>

